import { createRegexMatcher, Token, TokenDef, tokenize } from '@skylab-shared/utils';

export type NumberingTokenType = 'day' | 'month' | 'year' | 'number' | 'const' | 'whitespace';

export type NumberingTokenDef = TokenDef<NumberingTokenType>;

export type NumberingToken = Token<NumberingTokenType> & { asterisk?: boolean; };

const DAY_NUMBERING_TOKEN: NumberingTokenDef = {
    matcher: createRegexMatcher(/^\[\*?DD?\]/),
    type: 'day'
};

const MONTH_NUMBERING_TOKEN: NumberingTokenDef = {
    matcher: createRegexMatcher(/^\[\*?MM?\]/),
    type: 'month'
};

const YEAR_NUMBERING_TOKEN: NumberingTokenDef = {
    matcher: createRegexMatcher(/^\[\*?RR(RR)?\]/),
    type: 'year'
};

const NUMBER_NUMBERING_TOKEN: NumberingTokenDef = {
    matcher: createRegexMatcher(/^\[Numer\]/),
    type: 'number'
};

const WHITESPACE_NUMBERING_TOKEN: NumberingTokenDef = {
    matcher: createRegexMatcher(/^\s/),
    type: 'whitespace'
};

const CONSTANT_NUMBERING_TOKEN: NumberingTokenDef = {
    matcher: createRegexMatcher(/^(\S+?(?=(\[(Numer|\*?(DD?|MM?|RR(RR)?))\])))|\S+/),
    type: 'const'
};

const tokens = [
    DAY_NUMBERING_TOKEN,
    MONTH_NUMBERING_TOKEN,
    YEAR_NUMBERING_TOKEN,
    NUMBER_NUMBERING_TOKEN,
    WHITESPACE_NUMBERING_TOKEN,
    CONSTANT_NUMBERING_TOKEN
];

const extendNumberingToken = (token: Token<NumberingTokenType>): NumberingToken => ({
    ...token,
    asterisk: ['day', 'month', 'year'].includes(token.type) && token.content.includes('*')
});

export const tokenizeNumberingFormat = (input: string) => tokenize(tokens, input).map(extendNumberingToken);
